import CardWrapper from '../../components/wrapper/card';
import { fetchUserDetailThunk } from '../../redux/thunks';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { CancelRounded, CheckCircleRounded } from '@mui/icons-material';
import { green, red } from '../../theme/themePrimitives';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

const SubscriptionCallbackPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { isLoading } = useSelector((state: RootState) => state.app);
    const query = new URLSearchParams(useLocation().search);
    const success = query.get('success');

    const goToDashboard = async () => {
        try {
            await dispatch(fetchUserDetailThunk()).unwrap();
            navigate('/app/dashboard');
        } catch (e) {
            // Catch errors
        }
    };

    if (isLoading) {
        return <Box width="100vw" height="90vh" display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2}>
            <CircularProgress size="5vh" />
            <Typography variant="h5" fontWeight="bold" color="textSecondary">Loading...</Typography>
        </Box>;
    }

    if (success === '1') {
        return <Box padding="15px">
            <CardWrapper>
                <Box display="flex" flexDirection="column" alignItems="center" gap="20px" justifyContent="center" height="84vh">
                    <CheckCircleRounded sx={{
                        fontSize: '80px',
                        color: green[400]
                    }} />
                    <Typography variant="h2" fontWeight="bold" color="textSecondary">Payment Successful</Typography>
                    <Typography variant="subtitle1" color="textSecondary">Your subscription has been created successfully</Typography>
                    <Button variant="contained" onClick={goToDashboard}>Go to your Dashboard</Button>
                </Box>
            </CardWrapper>
        </Box>;
    }
    return (
        <Box padding="15px">
            <CardWrapper>
                <Box display="flex" flexDirection="column" alignItems="center" gap="20px" justifyContent="center" height="84vh">
                    <CancelRounded sx={{
                        fontSize: '80px',
                        color: red[300]
                    }} />
                    <Typography variant="h2" fontWeight="bold" color="textSecondary">Payment Failed</Typography>
                    <Typography variant="subtitle1" color="textSecondary">We encountered an issue while processing your subscription.</Typography>
                    <Button variant="contained" onClick={() => navigate('/app/subscription')}>Back to your Subscription</Button>
                </Box>
            </CardWrapper>
        </Box>
    );
};

export default SubscriptionCallbackPage;